import './Contents.css';

import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react'
import Alert from "react-bootstrap/Alert";
import Button from 'react-bootstrap/esm/Button';
import { hot } from 'react-hot-loader';
import { AiFillFile, AiOutlineFolder } from 'react-icons/ai';
import Selecto from "react-selecto";

import BaseButton from '../../../../../components/BaseButton';
import checkTotalSize from '../../../../../sdk/apis/checkTotalSize';
import retrieveSizeLimit from '../../../../../sdk/apis/retrieveSizeLimit';
import { downloadUrl, folderContentsUrl } from '../../../urls';
import styles from './Contents.module.scss';
import Image from './modal.png';


const ContentsList = ({ experiment, contents }) => {
  const [limit, setLimit] = useState(null);
  useEffect(() => {
    retrieveSizeLimit().then(result => {
      setLimit(result.total_size_limit);
    });
  }, []);

  const [ids, setIds] = useState([]);
  const idSet = useMemo(() => new Set(ids), [ids]);
  const [modalFlag, setModalFlag] = useState(false);


  // const [currentTotal, setCurrentTotal] = useState();
  // useEffect(() => {
  //   checkTotalSize(ids).then(result => {
  //     setCurrentTotal(getUnit(result.size));
  //   })
  // }, [ids]);

  const checkAll = () => {
    const allIds = [];
    contents.forEach((content) => {
      allIds.push(content.id);
    });
    setIds(allIds);
  }
  const uncheckAll = () => {
    setIds([]);
  }

  const getUnit = (size) => {
    let target = null;
    let unit = 'byte';

    const kb = 1024;
    const mb = Math.pow(kb, 2);
    const gb = Math.pow(kb, 3);
    const tb = Math.pow(kb, 4);

    if (size >= tb) {
      target = tb;
      unit = 'TB';
    } else if (size >= gb) {
      target = gb;
      unit = 'GB';
    } else if (size >= mb) {
      target = mb;
      unit = 'MB';
    } else if (size >= kb) {
      target = kb;
      unit = 'KB';
    }

    const res = target !== null ? Math.floor((size / target) * 100) / 100 : size;
    const result = res + ' ' + unit;
    return result;
  }

  const download = (ids) => {
    checkTotalSize(ids).then((result) => {
      if (result.allowed === true) {
        document.location = downloadUrl(ids);
      } else {
        const totalSize = getUnit(result.size);
        alert('選択されたファイルの合計サイズが大きすぎます。（上限: ' + limit + ' GB）\n選択されたファイルの合計サイズ: ' + totalSize + '\n※「ファイルダウンロード」ボタンから、単一ファイルをダウンロードする場合は、サイズ上限はありません。');
      }
    });
  }

  const fileList = contents.map((content) => {
    const checked = idSet.has(content.id);
    const contentSize = getUnit(content.size);
    if (content.type === 'F') { // ファイルに対する挙動を記述する。
      return (
        <div key={content.id} className='list'>
          <AiFillFile />
          <label id='file' className={classNames('file_list', checked && styles.blue)} style={{ display: 'inline-block', width: '40%', padding: '0.5em' }} data-id={content.id}>
            {content.name}
          </label>
          <label id='file' className={classNames('file_list', checked && styles.blue)} style={{ display: 'inline-block', width: '12%', padding: '0.5em' }} data-id={content.id}>
            <small>サイズ：{contentSize}</small>
          </label>
          <Button variant='outline-success' size="sm" onClick={() => document.location = downloadUrl([content.id])}>ファイルダウンロード</Button>
        </div>
      )
    };
  });

  const folderList = contents.map((content) => {
    const checked = idSet.has(content.id);
    const contentSize = getUnit(content.size);
    if (content.type === 'D') { // ディレクトリに対する挙動を記述する。
      return (
        <>
          <div key={content.id} className='list'>
            <AiOutlineFolder />
            <label id='folder' className={classNames('file_list', checked && styles.blue)} style={{ display: 'inline-block', width: '40%', padding: '0.5em' }} data-id={content.id}>
              {content.name}
            </label>
            <label id='folder' className={classNames('file_list', checked && styles.blue)} style={{ display: 'inline-block', width: '12%', padding: '0.5em' }} data-id={content.id}>
              <small>サイズ：{contentSize}</small>
            </label>
            <Button variant='outline-success' size='sm' onClick={() => download([content.id])} href='#' >フォルダダウンロード</Button>
            &nbsp;&nbsp;
            <Button variant='outline-danger' size='sm' href={folderContentsUrl(experiment.fiscal_year, content.experiment_id, content.id)} >フォルダ内のデータを表示</Button>
          </div>
        </>
      )
    }
  });

  const modalWindow = () => {
    if (!modalFlag) {
      return null
    } else {
      return (
        <>
          <div class="modal_content">
            <div className='overlay' onClick={() => { setModalFlag(false) }}>
              <div className='modalContents'>
                <div>
                  <img className='image' src={Image}></img>
                </div>
                <br></br>
                <div className='modalText'>
                  マウスドラッグでファイルの複数選択が可能です。<br></br>
                  Ctrlキーを押しながらドラッグすると、複数範囲を選択できます。<br></br>
                  選択したファイルをダウンロードするには、「zipダウンロード」ボタンを押下します。
                  ファイルサイズは計{limit}GBが上限です。<br></br>
                  <br></br>
                  単一のファイルをダウンロードしたい場合は、ファイル名の右側にある「ファイルダウンロード」ボタンを押下してください。<br></br>
                  単ファイルをダウンロードする場合、ファイルサイズの上限はありません。
                </div>
              </div>
            </div>
          </div>
        </>
      )
    }
  }

  const buttonContents = (
    <>
      <Button variant='secondary' size="sm" onClick={() => {
        setModalFlag(true);
      }}>ダウンロード機能の使い方</Button>
      {/* &nbsp;&nbsp;&nbsp;<small>※zipダウンロードの上限サイズは{limit}GBです。単ファイルダウンロードの場合は上限サイズはありません。</small> */}
      <br></br><br></br>
      <Button variant='success' size='ms' onClick={() => download(ids)}>zipダウンロード</Button>
      <BaseButton onClick={() => checkAll()}>全選択</BaseButton>
      <BaseButton onClick={() => {
        uncheckAll();
        setIds();
        // setCurrentTotal();
      }}>全解除</BaseButton>
      {/* <p><b>現在選択中のファイルサイズ合計（上限 {limit}GB）：{currentTotal}</b></p> */}
    </>
  );

  const fileListContents = (
    <>
      <div style={{ border: 'thick' }}>
        <br></br>
        <h4 className="font-weight-bold text-left">ファイル一覧</h4>
        <ul className="list-group">
          <div className='elements' styles={{ display: 'grid' }}>
            {fileList}
          </div>
        </ul>
      </div>
    </>
  );
  const folderListContents = (
    <>
      <br></br><br></br>
      <h4>フォルダ一覧</h4>
      <ul className="list-group">
        <div className='elements' styles={{ display: 'grid' }}>
          <div className='labels'>
            {folderList}
          </div>
        </div>
      </ul>
    </>
  );

  const [scrollOptions, setScrollOptions] = React.useState({});
  const scrollerRef = React.useRef(null);
  React.useEffect(() => {
    setScrollOptions({
      container: scrollerRef.current,
      throttleTime: 30,
      threshold: 0
    });
  }, []);

  const selecto = (
    <>
      <Selecto
        dragContainer={".elements"}
        selectableTargets={[".file_list"]}
        hitRate={0}
        // selectByClick={true}
        selectFromInside={true}
        continueSelect={false}
        continueSelectWithoutDeselect={true}
        toggleContinueSelect={["ctrl"]}
        toggleContinueSelectWithoutDeselect={[["ctrl"], ["meta"]]}
        ratio={0}
        scrollOptions={scrollOptions}
        onSelect={(e) => {
          const addedIds = e.added.map((e) => Number(e.dataset.id));
          const removedIds = e.removed.map((e) => Number(e.dataset.id));
          addedIds.forEach((id) => {
            idSet.add(id);
          });
          removedIds.forEach((id) => {
            idSet.delete(id);
          });
          setIds(Array.from(idSet));
        }}
        onScroll={e => {
          scrollerRef.current.scrollBy(e.direction[0] * 10, e.direction[1] * 10);
        }}
      ></Selecto>
    </>
  )

  // 配列の中身をチェックする。空の配列の時は表示しないようにする。
  // someメソッドでcheckを指定する。全てundefinedだとfalseを返す。
  const check = (e) => e !== undefined;

  if (folderList.some(check) === true && fileList.some(check) === false) {
    return [buttonContents, folderListContents, selecto, modalWindow()];
  } else if (folderList.some(check) === false && fileList.some(check) === true) {
    return [buttonContents, fileListContents, selecto, modalWindow()];
  } else {
    return [buttonContents, folderListContents, fileListContents, selecto, modalWindow()];
  }
};

export default hot(module)(ContentsList);
